import React from 'react'
import RasterLayer from './RasterLayer'

const IceDriftMagnitude = () => {
  return (
    <RasterLayer
      id='IceDriftMagnitude'
      authId='IceDrift'
      />
  )
}

export default IceDriftMagnitude



// WEBPACK FOOTER //
// ./src/layers/IceDriftMagnitude.js